export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkWhat: "nav-link-what",
  linkPlatforms: "nav-link-platforms",
  linkCx: "nav-link-cx",
  linkImpact: "nav-link-impact",
  linkFounder: "nav-link-founder",
  linkContact: "nav-link-contact",
  langToggle: "nav-lang-toggle",
  ctaPartner: "nav-cta-partner",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-root",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const PLATFORMS = {
  root: "platforms-root",
  card: (key) => `platform-card-${key}`,
  learn: (key) => `platform-learn-${key}`,
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  company: "contact-input-company",
  message: "contact-input-message",
  submit: "contact-submit",
};

export const FOOTER = {
  root: "footer-root",
};
